import { FunctionalComponent, h } from '@stencil/core';
import { PictureProps } from '../../elements/graphics/picture/picture';

export interface AuthorProps {
  authorName: string;
  authorDescription?: string;
  picture?: PictureProps;
}

export const Author: FunctionalComponent<AuthorProps> = ({authorName, authorDescription, picture}) => {
  return <rudy-modules-author authorName={authorName} authorDescription={authorDescription} picture={picture} />;
};
